var getUrlParameter;

getUrlParameter = function(sParam) {
  var i, len, sPageURL, sParameterName, sURLVariable, sURLVariables;
  sPageURL = decodeURIComponent(window.location.search.substring(1));
  sURLVariables = sPageURL.split('&');
  for (i = 0, len = sURLVariables.length; i < len; i++) {
    sURLVariable = sURLVariables[i];
    sParameterName = sURLVariable.split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[0];
    }
  }
};

if (getUrlParameter('newark')) {
  $.ajax({
    url: '/event/ajax-nearby-cities?type=1&buy-tickets-tab=1&count=3&from=' + window.myvars.serverRemoteAddr
  }).done(function(html) {
    $('#bottom-nearby-tips').html(html);
  });
}
